import { GuidedHighLightingWrapper } from "@/types/models/GuidedHighlighting.interface";

const getGuidedHighlightingQuizAttachment = (
  attachments: GuidedHighLightingWrapper[],
) => {
  if (!attachments) return;

  const guidedHighlightingQuiz = attachments.filter(
    (attachment) =>
      attachment.data?.assessment_type === "GUIDED_HIGHLIGHTING_QUIZ",
  );

  if (guidedHighlightingQuiz?.[0]?.data?.levels?.length === 0) return;

  return guidedHighlightingQuiz[0];
};

export default getGuidedHighlightingQuizAttachment;
